import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {faCogs} from "@fortawesome/free-solid-svg-icons";
import {ToastrService} from "ngx-toastr";
import {TranslocoService} from "@ngneat/transloco";
import {Id, IStationData, IUser} from "../../../interfaces";
import {AccessService, AppService, ContainerService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {compareIds, isHostDevOrLocal, isNullOrUndefOrEmpty, LargePageSizeOptions} from '../../../common';
import {ofType} from "@ngrx/effects";
import {actionLoadStationV2LogClear, actionLoadStationV2LogClearReply, actionLoadStationV2LogReply, actionLoadStationV2LogRequest} from "../../../store/actions/user.actions";
import {ActionsSubject} from "@ngrx/store";
import {StringJSV2Pipe} from "../../../pipes/stringjs-pipe";
import {isNull} from "lodash";

@Component({
    selector: 'app-station-log',
    templateUrl: './station-log.component.html',
    styleUrls: ['./station-log.component.scss']
})
export class StationLogComponent extends Compbaser implements OnInit, OnDestroy {

    @Output() toggleMinimize = new EventEmitter<any>();

    @Input()
    set filterByBusinessId(i_value: boolean) {
        this.m_filterByBusinessId = i_value;
    }

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input()
    set businessId(i_businessId: Id) {
        this.m_businessId = i_businessId;
    }

    m_stations: Array<IStationData>;
    m_stationLog = [];
    m_stationLogLastTime = 0;
    pageSizeOptions = LargePageSizeOptions;
    pageSize = 10;
    faCogs = faCogs;
    m_filterByBusinessId: boolean;
    dataSource: MatTableDataSource<IStationData>;
    m_businessId: Id;
    displayedColumns: string[] = ['station_name', 'stationId', 'time', 'priority', 'tag', 'message', 'className', 'fncName', 'fncArgs'];
    selection: SelectionModel<number>;
    center = {lat: 38, lng: -103};
    user: IUser;
    dashboard: boolean;
    debugMode;
    // globalFilter = '';

    globalFilterArg = '';
    globalFilterFunc = '';
    globalFilterMsg = '';
    globalFilterId = '';
    globalFilterClass = '';
    globalFilterTag = '';

    activeVersion = '0';
    lastGetTime;
    allowMultiSelect = false;
    stringJSPipeEpoc = {toDateFromTimestamp: ['MM-DD-YY HH:mm:ss']};

    constructor(public storeSelector: StoreSelectorsService,
                protected override dialog: MatDialog,
                private appService: AppService,
                public cdr: ChangeDetectorRef,
                private toastr: ToastrService,
                private stringJS: StringJSV2Pipe,
                private translocoService: TranslocoService,
                private accessService: AccessService,
                private containerService: ContainerService,
                private localStorage: LocalStoreService,
                private actionsSubj: ActionsSubject,
                private route: ActivatedRoute) {
        super();
        this.debugMode = isHostDevOrLocal();
        const initialSelection = [];
        this.selection = new SelectionModel<number>(this.allowMultiSelect, initialSelection);
        this.cod(
            this.actionsSubj.pipe(ofType(actionLoadStationV2LogReply))
                .subscribe((reply: any) => {
                    if (reply.logs.length === 0) {
                        this.m_stationLog = [];
                        return;
                    }
                    this.m_stationLog = reply.logs;
                    const last = reply.logs[reply.logs.length - 1];
                    if (!parseInt(last?.time)) return;
                    this.m_stationLogLastTime = last.time;
                    if (!this.m_stations) {
                        this.updateStations(reply.logs);
                        return;
                    }
                    reply.logs.forEach((i_station) => {
                        const stationFound = this.m_stations.find((f) => compareIds(f.props.station_id, i_station.stationId));
                        if (stationFound) {
                            i_station.station_name = stationFound.props.station_name;
                        }
                    });
                    this.updateStations(reply.logs);
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionLoadStationV2LogClearReply))
                .subscribe((reply: any) => {
                    this.m_stationLog = [];
                })
        );
        this.cod(
            this.storeSelector.getLastGetTime()
                .subscribe((v) => {
                    this.lastGetTime = v;
                })
        );
        this.cod(
            this.route.queryParams.subscribe(params => {
                if (params && params['filter']) {
                    this.applyFilter(params['filter'], '');
                }
            })
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                    this.dashboard = i_user.dashboard;
                    // if (this.dashboard) {
                    //     this.displayedColumns.push('businessId');
                    // }
                })
        );
        this.cod(
            this.storeSelector.getStationsComplete()
                .subscribe((v) => {
                    if (v.length === 0) return;
                    this.m_stations = v;
                })
        );
    }

    ngOnInit() {
        this.pageSize = parseInt(this.localStorage.getStorageValConfig('pageSize')) || 10;
        this.activeVersion = this.localStorage.getStorageValConfig('playersConnected') || '0';
        this.loadStationLog();
    }

    onFilterSelection(e) {
        this.selection.clear();
        this.clearFilter();
        // this.stationsUpdate();
    }

    onSwitchStation(e) {
        this.selection.clear();
        this.clearFilter();
        this.activeVersion = e.value + '';
        this.localStorage.setStorageValConfig('playersConnected', this.activeVersion);
    }

    /** Whether number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource?.data?.length;
        return numSelected === numRows;
    }

    applyFilter(filterValue: string, filterType) {
        switch (filterType) {
            case 'arg': {
                this.globalFilterArg = filterValue;
                break;
            }
            case 'func': {
                this.globalFilterFunc = filterValue;
                break;
            }
            case 'msg': {
                this.globalFilterMsg = filterValue;
                break;
            }
            case 'id': {
                this.globalFilterId = filterValue;
                break;
            }
            case 'class': {
                this.globalFilterClass = filterValue;
                break;
            }
            case 'tag': {
                this.globalFilterTag = filterValue;
                break;
            }
        }
        // this.globalFilter = filterValue;
        // if (this.dataSource) {
        this.dataSource.filter = JSON.stringify(this.globalFilterMsg);
        // }
    }

    loadStationLog() {
        this.storeSelector.dispatch(actionLoadStationV2LogRequest({
                payload: {
                    business_id: this.user.businessId,
                    from: this.m_stationLogLastTime
                }
            })
        );
    }

    clearStationLog() {
        this.storeSelector.dispatch(actionLoadStationV2LogClear({payload: {business_id: this.user.businessId}}));
        this.dataSource = new MatTableDataSource([]);
    }

    updateStations(sourceStations) {
        if (this.dataSource) {
            this.dataSource.data = sourceStations;
        }
        this.dataSource = new MatTableDataSource(sourceStations);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        // this.dataSource.filterPredicate = (data: any, filter) => {
        //     const dataStr = JSON.stringify(data).toLowerCase();
        //     return dataStr.indexOf(filter) !== -1;
        // };
        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.sortingDataAccessor = (item, property) => {
            return item[property];
        };
        if (!isNullOrUndefOrEmpty(this.activeVersion) && !compareIds(this.activeVersion, 0)) {
            this.onSwitchStation({value: this.activeVersion});
        }
        // if (this.globalFilter) {
        this.applyFilter(this.globalFilterMsg, 'msg');
        // }
    }

    private clearFilter() {
        // this.columnFilter.tree_path = '';
        this.applyFilter('', '');
    }

    private customFilterPredicate() {
        const myFilterPredicate = (data: any, filter: string): boolean => {
            let a = true;
            let b = true;
            let c = true;
            let d = true;
            let e = true;
            let f = true;

            if (isNullOrUndefOrEmpty(this.globalFilterMsg) && isNullOrUndefOrEmpty(this.globalFilterId) && isNullOrUndefOrEmpty(this.globalFilterArg) && isNullOrUndefOrEmpty(this.globalFilterFunc) && isNullOrUndefOrEmpty(this.globalFilterClass) && isNullOrUndefOrEmpty(this.globalFilterTag)) {
                return true;
            }
            if (!isNullOrUndefOrEmpty(this.globalFilterMsg)) {
                a = JSON.stringify(data.message).toString().toLowerCase().indexOf(this.globalFilterMsg.trim().toLowerCase()) !== -1;
            }
            if (!isNullOrUndefOrEmpty(this.globalFilterId)) {
                b = JSON.stringify(data.stationId).toString().toLowerCase().indexOf(this.globalFilterId.trim().toLowerCase()) !== -1;
            }
            if (data.arg && !isNullOrUndefOrEmpty(this.globalFilterArg)) {
                b = JSON.stringify(data.arg).toString().toLowerCase().indexOf(this.globalFilterArg.trim().toLowerCase()) !== -1;
            }
            if (data.class && !isNullOrUndefOrEmpty(this.globalFilterClass)) {
                b = JSON.stringify(data.class).toString().toLowerCase().indexOf(this.globalFilterClass.trim().toLowerCase()) !== -1;
            }
            if (data.func && !isNullOrUndefOrEmpty(this.globalFilterFunc)) {
                b = JSON.stringify(data.func).toString().toLowerCase().indexOf(this.globalFilterFunc.trim().toLowerCase()) !== -1;
            }
            if (data.tag && !isNullOrUndefOrEmpty(this.globalFilterTag)) {
                b = JSON.stringify(data.tag).toString().toLowerCase().indexOf(this.globalFilterTag.trim().toLowerCase()) !== -1;
            }

            if (a && b && c && d && e && f) return true;

            return false;
            // if (!globalMatch) {
            //     return false;
            // }
            // return true;
        };
        return myFilterPredicate;
    }
}


